import {
  PropsWithChildren,
  useMemo,
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
} from 'react';
import { defaultGuid } from '@equifinance/shared';
import { AuditHistory } from './Audit';
import { useAudit } from './useAudit';

export const defaultAuditHistory: AuditHistory = {
  applicationId: defaultGuid,
  auditRecord: [],
};

export type AuditContextType = {
  auditHistory: AuditHistory,
  setAuditHistory: Dispatch<SetStateAction<AuditHistory>>,
  fetchAuditHistory(): Promise<void>,
}

const defaultAuditContext: AuditContextType = {
  auditHistory: defaultAuditHistory,
  setAuditHistory: () => {},
  fetchAuditHistory: async () => {},
};

export const AuditContext = createContext<AuditContextType>(
  defaultAuditContext,
);

export function useAuditContext() {
  return useContext(AuditContext);
}

export function AuditProvider({ id, children }: PropsWithChildren<{ id: string }>) {
  const audit = useAudit(id);

  const contextValue = useMemo(() => ({ ...audit }), [audit]);

  return (
    <AuditContext.Provider value={contextValue}>
      {children}
    </AuditContext.Provider>
  );
}
